import React, { createContext, useState, useEffect } from "react";
import { AuthenticationProvider, InMemoryWebStorage, OidcSecure } from "@axa-fr/react-oidc-context";

const hostPath = (path) => {
  return window.location.protocol + "//" + window.location.host + "/" + (path ? path : "");
};

const initialState = {
  client_id: undefined, // set by loading '/_configuration/oidc.json'
  authority: undefined, // set by loading '/_configuration/oidc.json'
  redirect_uri: hostPath("authentication/callback"),
  response_type: "code",
  post_logout_redirect_uri: hostPath(),
  silent_redirect_uri: hostPath("authentication/silent_callback"),
  automaticSilentRenew: true,
  scope: "openid profile email",
};

const OidcContext = createContext();

export const OidcProvider = ({ children }) => {
  const [oidcConfiguration, setOidcConfiguration] = useState(initialState);

  const Message = (message) => {
    return !message ? null : <h1>{message}</h1>;
  };

  const Blank = () => Message();

  useEffect(() => {
    fetch(hostPath("_configuration/oidc.json"))
      .then((response) => response.json())
      .then((json) => {
        setOidcConfiguration({
          ...oidcConfiguration,
          client_id: json.client_id,
          authority: json.authority,
        });
      });
  }, []);

  return !oidcConfiguration.authority ? null : (
    <OidcContext.Provider value={oidcConfiguration}>
      <AuthenticationProvider
        configuration={oidcConfiguration}
        UserStore={InMemoryWebStorage}
        notAuthenticated={() => Message("Not authenticated")}
        authenticating={Blank}
        callbackComponentOverride={Blank}
        notAuthorized={Blank}
        sessionLostComponent={Blank}
      >
        <OidcSecure>{children}</OidcSecure>
      </AuthenticationProvider>
    </OidcContext.Provider>
  );
};
